<pmis3-vessel-visit [seaports]="seaports()"
                    [statuses]="transitStatuses()"
                    [vesselOrientations]="vesselOrientations()"
                    [vessels]="vessels()"
                    [locations]="locations()"
                    [vesselVisitDTOs]="vesselVisits()"
                    [organizationTypes]="organizationTypes()"
                    [organizations]="organizations()"
                    [vesselActivityPurposes]="vesselStopPurposes()"
                    [ladenStatuses]="ladenStatuses()"
                    [locationTypes]="locationTypes()"
                    [serviceApplicationTypes]="serviceApplicationTypes()"
                    [vesselVisit]="vesselVisit()"
                    [agentOrganizationId]="agentOrganizationId()"
                    [cargoTypes]="cargoTypes()"
                    [cargoUnitTypes]="cargoUnitTypes()"
                    [cargoOperations]="cargoOperations()"

                    (submitNOA)="onSubmitNOA($event)"
                    (saveNOA)="onSaveNOA($event)"
                    (getVesselVisitById)="onGetVesselVisitById($event)"
                    (from)="onLoadVesselVisitsByDateRangeFrom($event)"
                    (to)="onLoadVesselVisitsByDateRangeTo($event)"
                    (searchQuery)="onSearchQuery($event)"
                    (statusFilter)="onStatusFilerChange($event)"
                    (getVesselVisits)="onGetVesselVisits()"
></pmis3-vessel-visit>